import React, { Component } from 'react';
import ColorBox from './ColorBox';
import Navbar from './Navbar';
import styles from './styles/PaletteStyles';
import { withStyles } from '@material-ui/styles';
import PaletteFooter from './PaletteFooter';

export default withStyles(styles)(
	class Palette extends Component {
		constructor(props) {
			super(props);
			this.state = { level: 500, format: 'hex' };
			this.changeLevel = this.changeLevel.bind(this);
			this.changeFormat = this.changeFormat.bind(this);
		}
		changeLevel(newLevel) {
			this.setState({ level: newLevel });
		}
		changeFormat(value) {
			this.setState({ format: value });
		}
		render() {
			const { colors, paletteName, emoji, id } = this.props.palette;
			const { classes } = this.props;
			const { level, format } = this.state;
			const colorBoxes = colors[level].map((color) => (
				<ColorBox
					background={color[format]}
					name={color.name}
					key={color.id}
					moreUrl={`/palette/${id}/${color.id}`}
					showingFullPalette
				/>
			));
			return (
				<div className={classes.Palette}>
					<Navbar level={level} changeLevel={this.changeLevel} handleChange={this.changeFormat} showingAllColors />
					<div className={classes.colors}>{colorBoxes}</div>
					<PaletteFooter paletteName={paletteName} emoji={emoji} />
				</div>
			);
		}
	}
);
